import React, { useState, useEffect } from "react";
import { connectWisdomWallet, ensureWisdomChainForContract } from "../../chain";
import "../../styles/BuyTokens.css";

const BuyTokens = () => {
    const [message, setMessage] = useState("");
    const [amount, setAmount] = useState("");
    const [walletAddress, setWalletAddress] = useState("");
    const [isPurchasing, setIsPurchasing] = useState(false);
    const [balance, setBalance] = useState(0);

    useEffect(() => {
        // Check wallet connection on component mount
        const checkWallet = async () => {
            try {
                const account = localStorage.getItem("user");
                if (account) {
                    setWalletAddress(account);
                    // Fetch balance
                    await fetchBalance(account);
                }
            } catch (error) {
                console.error("Error checking wallet:", error);
            }
        };
        checkWallet();
    }, []);

    const fetchBalance = async (address) => {
        // This is a placeholder - in a real implementation, you would call the token contract
        // to get the actual balance
        try {
            // Simulate balance fetch
            setBalance(0);
        } catch (error) {
            console.error("Error fetching balance:", error);
        }
    };

    const handleBuyTokens = async () => {
        if (!window.ethereum) {
            setMessage("MetaMask is required to buy tokens.");
            return;
        }

        if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
            setMessage("Please enter a valid amount of tokens to buy.");
            return;
        }

        try {
            // Connect wallet if not already connected
            let account = walletAddress;
            if (!account) {
                account = await connectWisdomWallet();
                setWalletAddress(account);
            }

            // Ensure we're on the Wisdom chain
            await ensureWisdomChainForContract("0xWisdomTokenContractAddress");
            
            // In a real implementation, you would:
            // 1. Call the smart contract to buy tokens
            // 2. Handle the transaction
            // 3. Update the user's balance
            setMessage(`Successfully initiated token purchase for ${amount} WSD tokens. Please confirm the transaction in MetaMask.`);
            setIsPurchasing(true);
            
            // Simulate purchase process
            setTimeout(() => {
                setMessage(`Purchase of ${amount} WSD tokens completed successfully!`);
                setIsPurchasing(false);
                setAmount("");
                // In a real app, we would update the balance here
            }, 2000);
            
        } catch (error) {
            console.error("Error buying tokens:", error);
            setMessage(error?.message || "An error occurred while purchasing tokens.");
            setIsPurchasing(false);
        }
    };

    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    return (
        <div className="buy-tokens">
            <h1>Buy WSD Tokens</h1>
            <p>Buy Wisdom Academy tokens (WSD) to pay for courses and other platform features.</p>
            
            {walletAddress && (
                <div className="wallet-info">
                    <p>Connected wallet: <strong>{walletAddress.substring(0, 6)}...{walletAddress.substring(walletAddress.length - 4)}</strong></p>
                    <p>Current WSD balance: <strong>{balance} WSD</strong></p>
                </div>
            )}
            
            <div className="buy-form">
                <div className="form-group">
                    <label htmlFor="amount">Amount of WSD to buy:</label>
                    <input 
                        type="number" 
                        id="amount"
                        value={amount}
                        onChange={handleAmountChange}
                        placeholder="Enter amount of WSD tokens"
                        min="0.01"
                        step="0.01"
                    />
                </div>
                
                <button 
                    onClick={handleBuyTokens} 
                    disabled={isPurchasing || !amount || parseFloat(amount) <= 0}
                    className="buy-button"
                >
                    {isPurchasing ? "Processing Purchase..." : "Buy Tokens"}
                </button>
            </div>
            
            {message && <p className="message">{message}</p>}
            
            <div className="info-section">
                <h3>How It Works</h3>
                <ul>
                    <li>WSD tokens are the native currency of Wisdom Academy</li>
                    <li>Use WSD tokens to pay for premium courses and features</li>
                    <li>Purchases are made on the Wisdom blockchain (chain 2307)</li>
                    <li>Connect your MetaMask wallet to proceed</li>
                </ul>
            </div>
        </div>
    );
};

export default BuyTokens;